import React from 'react';
import PropTypes from 'prop-types';
import { Link, useStaticQuery, graphql } from 'gatsby';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import FeatureBlock from 'common/src/components/FeatureBlock';
import Container from 'common/src/components/UI/Container';

import SectionWrapper from './feature.style';

const FeatureSection = ({
  secTitleWrapper,
  secText,
  secHeading,
  row,
  col,
  FeatureItemStyle,
  iconStyle,
  contentStyle,
  featureTitle,
  featureDescription,
}) => {
  const Data = useStaticQuery(graphql`
    query {
      saasClassicJson {
        FEATURES {
          title
          description
          icon
          imgUrl
          pageUrl
        }
      }
    }
  `);

  return (
    <SectionWrapper id="feature_section">
      <Container>
        <Box {...secTitleWrapper}>
          <Text {...secText} content="" />
          <Link to="/blog">
            <Heading
              {...secHeading}
              content="Transcripts from our favorite podcasts"
            />
          </Link>
        </Box>

        <Box {...row}>
          {Data.saasClassicJson.FEATURES.map((item, index) => (
            //console.log(item)
            <Box {...col} key={`feature-item-${index}`} className="feature_col">
              <FeatureBlock
                // icon={<i className={item.icon} />}
                icon={
                  <Link to={item.pageUrl}>
                    <img
                      src={item.imgUrl}
                      style={{
                        borderRadius: '5px',
                        height: '150%',
                        width: '150%',
                      }}
                    />{' '}
                  </Link>
                }
                // icon={
                //   <a href={item.pageUrl}>
                //     {' '}
                //     <img
                //       src={item.imgUrl}
                //       style={{ borderRadius: '5px', height: '10%' }}
                //     />{' '}
                //   </a>
                // }
                wrapperStyle={FeatureItemStyle}
                iconStyle={iconStyle}
                contentStyle={contentStyle}
                iconPosition="left"
                title={
                  <Link to={item.pageUrl}>
                    {' '}
                    <Heading content={item.title} {...featureTitle} />{' '}
                  </Link>
                }
                // description={
                //   <Link to={item.pageUrl}>
                //     {' '}
                //     <Text
                //       content={item.description}
                //       {...featureDescription}
                //     />{' '}
                //   </Link>
                // }
              />
            </Box>
          ))}
        </Box>
      </Container>
    </SectionWrapper>
  );
};

FeatureSection.propTypes = {
  sectionHeader: PropTypes.object,
  sectionWrapper: PropTypes.object,
  secTitleWrapper: PropTypes.object,
  secText: PropTypes.object,
  secHeading: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  FeatureItemStyle: PropTypes.object,
  iconStyle: PropTypes.object,
  contentStyle: PropTypes.object,
  featureTitle: PropTypes.object,
  featureDescription: PropTypes.object,
};

FeatureSection.defaultProps = {
  secTitleWrapper: {
    mb: ['60px', '100px'],
  },
  secText: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '14px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: '#ff4362',
    mb: '12px',
  },
  secHeading: {
    textAlign: 'center',
    fontSize: ['20px', '24px', '36px', '36px'],
    fontWeight: '700',
    color: 'white',
    // color: '#0f2137',
    letterSpacing: '-0.025em',
    mb: '0',
    ml: 'auto',
    mr: 'auto',
    lineHeight: '1.12',
    width: '540px',
    maxWidth: '100%',
  },
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: ['-30px', '-30px', '-30px', '-25px', '-30px'],
    mr: ['-30px', '-30px', '-30px', '-25px', '-45px'],
  },
  col: {
    width: [1, 1 / 2, 1 / 2, 1 / 3],
    pl: ['30px', '30px', '30px', '25px', '45px'],
    pr: ['30px', '30px', '30px', '25px', '45px'],
    mb: ['50px', '70px'],
  },
  FeatureItemStyle: {},
  iconStyle: {
    width: ['72px', '72px', '72px', '72px', '82px'],
    height: ['72px', '72px', '72px', '72px', '82px'],
    mr: '20px',
    borderRadius: ['20px', '20px', '20px', '20px', '28px'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bg: '#ffecef',
    color: '#ff4361',
    fontSize: ['26px', '26px', '26px', '26px', '30px'],
  },
  featureTitle: {
    fontSize: ['17px', '19px'],
    fontWeight: '500',
    color: 'black',
    // color: '#0f2137',
    letterSpacing: '-0.020em',
    lineHeight: '1.5',
    ml: ['30px'],
    mb: ['10px', '13px'],
  },
  featureDescription: {
    fontSize: '15px',
    fontWeight: '400',
    color: '#5d646d',
    letterSpacing: '-0.025em',
    lineHeight: '1.88',
    ml: ['30px'],
    mb: 0,
  },
};

export default FeatureSection;
